var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bouts"},[_c('div',{staticClass:"bout-roller"},_vm._l((_vm.posts),function(bout,index){return _c('marquee-text',{key:index,attrs:{"repeat":6}},[_c('BoutsList')],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }